export default {
  UPDATE_CREDENTIALS: "UPDATE_CREDENTIALS",
  UPDATE_LAST_ACTIVITY: "UPDATE_LAST_ACTIVITY",
  LOGOUT: "LOGOUT",
  UPDATE_LOADING_MESSAGE: "UPDATE_LOADING_MESSAGE",
  UPDATE_COLOR_SCHEME: "UPDATE_COLOR_SCHEME",
  UPDATE_WINDOW_DIMENSIONS: "UPDATE_WINDOW_DIMENSIONS",
  UPDATE_SCROLLBAR_WIDTH: "UPDATE_SCROLLBAR_WIDTH",
};